import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import fallback from '../../assets/raffle-models/trophy-front.png';

const Cup = styled.div`
  position: relative;
  width: min(100%, 320px);
  height: clamp(170px, 25vh, 250px);
  flex-shrink: 0;
  margin: -10px 0 -4px;
  & > .cup-render, & > img { position: absolute; inset: 0; width: 100%; height: 100%; }
  & canvas { display: block; width: 100%; height: 100%; }
  & > img { object-fit: contain; }
  & > img[hidden] { display: none; }
`;

export default function ChampionshipCup() {
  const container = useRef(null);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let cancelled = false, dispose;
    import('./createChampionshipCup').then(({ default: create }) => {
      if (cancelled) return;
      dispose = create(container.current);
      setReady(true);
    }).catch(() => { /* Keep the local trophy image when WebGL is unavailable. */ });
    return () => { cancelled = true; dispose?.(); };
  }, []);
  return (
    <Cup aria-hidden="true">
      <img src={fallback} alt="" hidden={ready} />
      <div className="cup-render" ref={container} />
    </Cup>
  );
}
